import type {ReactElement} from 'react';
import {SkeletonBrick} from '@Components/skeleton-brick';
import styles from './canvas-loading-skeleton.module.scss';

export function CanvasLoadingSkeleton(): ReactElement {
  return (
    <div className={styles.overlay} aria-hidden>
      <div className={styles.card}>
        <SkeletonBrick className={styles.heading} height={28} />
        <div className={styles.fields}>
          {Array.from({length: 3}, (_, i) => (
            <div key={i} className={styles.fieldRow}>
              <SkeletonBrick className={styles.label} height={14} />
              <SkeletonBrick height={40} />
            </div>
          ))}
        </div>
        <SkeletonBrick height={44} />
      </div>
    </div>
  );
}
